import { Model, util } from '@glu/core';

export default Model.extend({
  getGroupTitle() {
    const title = this.get('title');
    let groupTitle = title || (this.get('currentTitle') || this.get('currentValue'));

    if (util.isFunction(title)) {
      groupTitle = title(this.get('currentTitle') || this.get('currentValue'));
    }

    return groupTitle;
  }
});
